import React, { Component } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import {
  TextField,
  Button,
  Collapse,
  Alert,
  IconButton,
  Typography,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Serverurl from "./Apiurl";
import JoditEditor from "jodit-react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";



const fieldStyle = {
  backgroundColor: "#f5f6f8",
  borderRadius: "10px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
  
    "& fieldset": {
      borderColor: "#d1d5db",
    },
    "&:hover fieldset": {
      borderColor: "#9ca3af",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1976d2",
    },
  },
  "& .MuiInputBase-input": {
    padding: "12px 14px !important",
   
    color: "#000",
  },
};


export default class AddProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pr_id: 0,
      pr_name: "",
      pr_price: "",
      pr_gst: "",
      pr_description: "",
      pr_hsncode: "",
      redirect: false,
      btndisabled: false,
      submitbtn: "Save",
      erropen: false,
      errormessage: "",
      pagename: ""
    };
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase();
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  componentWillMount() {
    let search = window.location.href;
    let pid = this.getParameterByName("pid", search);

    if (localStorage.getItem("GBuserid") == null) {
      this.setState({
        redirect: true,
        pagename: "/Businesslogin"
      });
      return;
    }

    if (pid !== null && pid !== "") {
      this.getProductData(pid);
    }
  }

  getProductData = (id) => {
    axios
      .get(Serverurl + "ajaxproduct.php?action=getall&pr_id=" + id)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          const product = res.data[0];
          this.setState({
            pr_id: product.pr_id, // Ensures the existing product ID is retained
            pr_name: product.pr_name || "",
            pr_price: product.pr_price || "",
            pr_gst: product.pr_gst || "",
            pr_description: product.pr_description || "",
            pr_hsncode: product.pr_hsncode || ""
          });
        } else {
          this.setState({
            pr_id: 0,
            pr_name: "",
            pr_price: "",
            pr_gst: "",
            pr_description: "",
            pr_hsncode: ""
          });
        }
      });
  };

  myChangeHandler = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleErrorclose = () => {
    this.setState({ erropen: false, errormessage: "" });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.pr_name) return this.showError("Please Enter Product Name");
    if (!this.state.pr_price) return this.showError("Please Enter Price");
    if (!this.state.pr_gst) return this.showError("Please Enter GST");

    this.setState({ btndisabled: true, submitbtn: "Processing..." });

    const formData = new FormData();

    formData.append("action", "insertorupdate");
    formData.append("pr_id", this.state.pr_id); // Sending existing pr_id tells backend to UPDATE instead of INSERT
    formData.append("pr_name", this.state.pr_name);
    formData.append("pr_price", this.state.pr_price);
    formData.append("pr_gst", this.state.pr_gst);
    formData.append("pr_description", this.state.pr_description);
    formData.append("pr_hsncode", this.state.pr_hsncode);
    formData.append("userid", localStorage.getItem("GBuserid"));
    formData.append("pr_bu_id", localStorage.getItem("GBuserid"));

    axios.post(Serverurl + "ajaxproduct.php", formData).then((res) => {
      const productId = Array.isArray(res.data)
        ? res.data[0]?.pr_id
        : typeof res.data === "object"
        ? res.data.pr_id
        : res.data;

      if (productId && productId !== -1) {
       if (this.props.quotationMode || this.props.invoiceMode) {
  const product = {
    pr_id: productId,
    pr_name: this.state.pr_name,
    pr_price: this.state.pr_price,
    pr_gst: this.state.pr_gst,
    pr_hsncode: this.state.pr_hsncode
  };

  this.props.onProductAdded(product);
} else {
  this.setState({
    redirect: true,
    pagename: "/Productlist"
  });
}
      } else if (productId === -1) {
        this.showError("Product name already exists");
      } else {
        this.showError("Error saving product");
      }
    });
  };

  showError = (msg) => {
    this.setState(
      {
        erropen: true,
        errormessage: msg,
        btndisabled: false,
        submitbtn: "Save"
      },
      () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    );
  };

  Handledescripion = (newValue) => {
    this.setState({
      pr_description: newValue
    });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
		<React.Fragment>
      <div className="formmain">
        <Box
          sx={{
            display: "flex",
            justify: "space-between",
            mb: 3,
            marginBottom: "10px"
          }}
        >
		{!this.props.quotationMode && (
          
            <IconButton
              onClick={() =>
                this.setState({ redirect: true, pagename: "/Productlist" })
              }
            >
                 <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>
            </IconButton>
			 )}
            <Typography variant="h4" sx={{ marginTop:1 }}>Products</Typography>
        </Box>

        <Collapse in={this.state.erropen}>
          <Alert
            severity="error"
            action={
              <IconButton
                aria-label="close"
                size="small"
                onClick={this.handleErrorclose}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {this.state.errormessage}
          </Alert>
        </Collapse>

        <form onSubmit={this.handleSubmit}>
			{/*   <p>
            <span className="validation">*</span>Product Name
			</p>*/}
          <p>
            <TextField
			label="Product Name"
              name="pr_name"
			      placeholder="Product Name"
              value={this.state.pr_name}
              onChange={this.myChangeHandler}
			  InputLabelProps={{ shrink: true }}
              fullWidth
              margin="normal"
              inputProps={{ maxLength: 150, tabIndex: 1 }}
			  sx={fieldStyle}
            />
          </p>

		  {/* <p>
            <span className="validation">*</span>Price
          </p>*/}
          <p>
            <TextField
			label="Price"
              name="pr_price"
			  placeholder="Price"
              value={this.state.pr_price}
              inputProps={{ tabIndex: 2 }}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9.]/g, "");
                if (value.length <= 8) {
                  this.setState({ pr_price: value });
                }
              }}
			   InputLabelProps={{ shrink: true }}
              fullWidth
              margin="normal"
			   sx={fieldStyle}
            />
          </p>

		  {/*  <p>
            <span className="validation">*</span>GST(%)
          </p>*/}
          <p>
            <TextField
			label="GST(%)"
              name="pr_gst"
			   placeholder="GST(%)"
              value={this.state.pr_gst}
              onChange={this.myChangeHandler}
             InputLabelProps={{ shrink: true }}
              fullWidth
              margin="normal"
             inputProps={{ maxLength: 2, inputMode: 'numeric' }}
			 sx={fieldStyle}
            />
          </p>

		  {/* <p>Description</p> */}
		  
          <p>
            <JoditEditor
			label="Description"
			placeholder="Description"
	config={{
    style: {
      background: '#f0f4f7', 
      minHeight: '140px !important'
    },

    removeButtons: ['video'],
  }}
              value={this.state.pr_description}
              tabIndex={4}
              onChange={this.Handledescripion}
			  InputLabelProps={{ shrink: true }}
              name="pr_description"
			   sx={fieldStyle}
            />
          </p>

          {/*<p>HSN Code</p>*/}
          <p>
		 
            <TextField
			 label="HSN Code"
              name="pr_hsncode"
			  placeholder="HSN Code"
              value={this.state.pr_hsncode}
              onChange={this.myChangeHandler}
			  InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 10, tabIndex: 5 }}
              fullWidth
              margin="normal"
			     sx={fieldStyle}
            />
          </p>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
              type="submit"
              variant="contained"
              disabled={this.state.btndisabled}
              className="primartybtn"
             		  sx={{
   
    borderRadius: "20px",
    minWidth: "110px",
  }}
            >
              {this.state.submitbtn}
            </Button>
          </Box>
        </form>
      </div>
	  	</React.Fragment>
    );
  }
}